import { REST_API_ORIGIN, resolveEndpoints } from '../platform/endpoints';

export function resolveApiOrigin(options) {
  return options ? resolveEndpoints(options).restOrigin : REST_API_ORIGIN;
}

export const API_ORIGIN = REST_API_ORIGIN;
